import {Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {ProductsArticleService} from './products-article.service';
import {StocksService} from './stocks.service';
import {ProductsArticle} from './products-article';
import {SerialNumber} from './serial-number-type';
import {ProductsCategoryService} from './products-category.service';
import {ProductsCategory} from './products-category';
import {AppComponent} from './app.component';
import {Lots} from './lots';
import {ProductsAbstractService} from './products-abstract.service';
import {ProductsLotAbstract} from './products-lot-abstract';
import {ProductsMovementAbstract} from './products-movement-abstract';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {StockArticleComponent} from './stock-article.component';
import {StockArticleService} from './stock-article.service';
import {FileDownloadService} from './file-download.service';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'stock-initial',
    templateUrl: './templates/stock-initial.component.html',
    styleUrls: ['./styles/stock-initial.component.css'],
    providers: [FileDownloadService,
        ProductsCategoryService,
        ProductsArticleService,
        StocksService,
        ProductsAbstractService,
        AuthentificationService,
        SortTable,
        StockArticleComponent,
        StockArticleService],
    encapsulation: ViewEncapsulation.None
})

export class StockInitialComponent implements OnInit {
    session_mode: string = "RECEPTION";
    position: string = 'before';
    receipt: string = "RECEIPTION";
    modification: string = "MODIFICATION";
    management_mode: string = "";
    src_bt = "../../img/ico_modif.png";
    current_article: ProductsArticle = {
        id_article: 0,
        name: '',
        internal_code: '',
        reference_code: '',
        supplier_code: '',
        reference: '',
        type: '1',
        category: '1',
        conditioning: '',
        counting_unit: '',
        description: '',
        ht_selling_price: 0,
        supply_thershold: '',
        expiration_thershold: '',
        managed_by_lot: '',
        managed_by_serial: '',
        issue_mode: '',
        stocks: 0,
        stock_mini: 0,
        stock_maxi: 0,
        type_name: "",
    };
    name = "";
    verification_serial_txt = "Tapez un numéro de série";
    operation_bt = 'Ajouter';
    serialtext: string = "";
    article_management: string = "";
    serial_management = "";
    lot_management = "";
    receip_mode: boolean = false;
    issue_mode: boolean = false;
    validate_active: boolean = false;

    quantity: number = 1;
    internal_code: string;
    reference_code: string;
    name_art: string;
    category: string = 'root';
    indexofModif: number;
    id_article: number;
    docket_name: string = 'Stock Initial';

    ischecked: boolean = false;
    isOut: boolean = false;
    unmanaged_by_serial: boolean = true;
    add_bt: boolean = true;
    qte_disabled: boolean = true;
    valid_bt: boolean = true;
    serial_ok: string;
    edit_serial_avalable: boolean = false;

    prod_list: ProductsArticle[];
    prod_session_list: Array<Object>;
    serial_selected_list: Array<string> = [];
    serial_number_list: SerialNumber[] = [];
    cat_list: ProductsCategory[];

    serial_value = "Entrer le numéro de série";

    stock_sup: boolean = false;
    lot_name: string;
    lot_name_select: string;
    lot: string;
    serial_number: string;

    serial_number_disabled: boolean = true;
    lot_disabled: boolean = true;
    lot_select_disabled: boolean = true;

    lot_list: Lots[];
    already_in: boolean = false;

    public list: string[];
    validate_docket_bt: boolean = true;
    lot_abstract: ProductsLotAbstract[];
    movement_list: ProductsMovementAbstract[];
    info_article: string;

    tmp: number;
    hide_lot_infos: boolean = false;
    article_abstract_id: number = 0;
    sortedData: any = [];
    form_not_valid: boolean = false;
    docket_date: any = new Date();

    constructor(private products_article_service: ProductsArticleService,
        private stocks_service: StocksService,
        private route: ActivatedRoute,
        private product_category_service: ProductsCategoryService,
        private app_component: AppComponent,
        private lots_service: StocksService,
        private products_abstract_service: ProductsAbstractService,
        private router: Router,
        private authentification_service: AuthentificationService,
        private sort_table: SortTable,
        private stock_article_service: StockArticleService,
        private filedownloadservice: FileDownloadService,
        private datepipe: DatePipe
    ) {
        this.CheckUSerSession();
        this.app_component.valTest = '/initial-stock';
        this.app_component.GetParent();
    }

    ngOnInit(): void {
        this.LoadSessionDocket();
        this.Search();
        this.GetCategoriesList();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    articleToSend(event: any) {
        this.ChoisedArticleAdd(event);
    }

    GetArticlesLotInfos(article: ProductsArticle, i: number): void {
        this.article_abstract_id = article.id_article;
        if (this.tmp === i) {
            this.hide_lot_infos = true;
            this.tmp = -1;
            this.hide_lot_infos = false;
        } else {
            this.GetLotAbstract(article);
            this.tmp = i;
        }
    }

    LoadSessionDocket(): void {
        this.stocks_service.LoadSessionDocket().then(result => {this.prod_session_list = result['list']; this.number_reference = parseInt(result['last_number_reference']) + 1; this.docket_name = this.docket_name; if (result['list'].length !== 0) {this.validate_docket_bt = false} });
    }

    GetMovementAbstract(article: ProductsArticle): void {
        this.products_abstract_service.GetMovementAbstract(article.id_article).then(movement_list => this.movement_list = movement_list);
    }

    GetLotAbstract(article: ProductsArticle): void {
        this.products_abstract_service.GetLotAbstract(article.id_article).then(lot_abstract => this.lot_abstract = lot_abstract['lot_abstract_list']);
    }

    GetLotsList(id_article: number): void {
        this.lots_service.GetLotsList(id_article).then(lot_list => this.lot_list = lot_list);
    }

    GetCategoriesList(): void {
        this.product_category_service.GetCategoriesList().then(cat_list => this.cat_list = cat_list);
    }

    GetSerialList(id_article: number): void {
        this.stocks_service.GetSerialList(id_article).then(serial_number_list => this.serial_number_list = serial_number_list);
    }

    VerificationSerialNumberInOut(id_article: number, serial_value: string): void {
        this.stocks_service.VerificationSerialNumberInOut(id_article, serial_value).then(serial_ok => {this.Verif_in_out_cb(serial_ok)});
    }

    VerificationSerialNumberOut(id_article: number, serial_value: string): void {
        this.stocks_service.VerificationSerialNumberOut(id_article, serial_value).then(serial_ok => {this.Verif_out_cb(serial_ok); this.GetResponse(serial_ok)});
    }

    Search(): void {
        this.products_article_service.Search(this.internal_code, this.reference_code, this.name_art, this.category).then(prod_list => {this.GetArticle_cb(prod_list); this.sortedData = prod_list; this.sort_table.SetDataArray(prod_list, [{value: "internal_code", type: ""}, {value: "name", type: ""}, {value: "cat", type: ""}, {value: "stocks", type: "number"}]);});
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
    }

    SetReceipOperation(product: ProductsArticle): void {
        this.current_article = product;

        this.InitForm();
        this.GetLotsList(product.id_article);

        this.name = product.name;
        this.qte_disabled = false;

        this.valid_bt = false;
        this.id_article = product.id_article;
        this.management_mode = product.managed_by_serial;

        if (product.managed_by_serial === 'UNMANAGED_BY_SERIAL' || product.managed_by_serial === 'OUT') {
            this.serial_number_disabled = true;
            this.serial_value = "Non géré par numéro de série en entrée";
        }
        else {
            this.quantity = 1;
            this.qte_disabled = true;
            this.serial_number_disabled = false;
            this.serial_value = "Entrer le numéro de série";
            this.SerialNumberCtl();
        }
        if (product.managed_by_lot === '0') {
            this.lot_disabled = true;
            this.lot_select_disabled = true;

        } else {
            this.lot_disabled = false;
            this.lot_select_disabled = false;
        }

        this.ManagementInfos(product);
        this.receip_mode = true;
        this.app_component.hide_wrapper(this.receip_mode);
    }

    ManagementInfos(product: ProductsArticle): void {
        if (product.managed_by_lot === '0') {
            this.lot_management = '( Non géré par lot -';
        } else if (product.managed_by_lot === '1') {
            this.lot_management = '( Géré par lot -';
        }
        if (product.managed_by_serial === 'OUT') {
            this.serial_management = 'géré par numéro de série en sortie )';
        } else if (product.managed_by_serial === 'IN_OUT') {
            this.serial_management = 'géré par numéro de série en entrée / sortie )';
        } else if (product.managed_by_serial === 'UNMANAGED_BY_SERIAL') {
            this.serial_management = 'non géré par numéro de série )';
        }
    }

    ChoisedArticleAdd(product: ProductsArticle): void {
        this.SetReceipOperation(product);
        this.ManagementInfos(product);
    }

    InitPopup(): void {
        this.receip_mode = false;
        this.issue_mode = false;
        this.app_component.hide_wrapper(this.issue_mode);
        this.validate_active = false;
        this.stock_sup = false;
    }

    Cancel(): void {
        this.InitPopup();
    }

    Verif_local(): void {
        var index = this.serial_selected_list.indexOf(this.serialtext.trim());
        if (index > -1) {
            this.serialtext = "";
            this.verification_serial_txt = "Cet numéro de série est déjà dans la liste";
            setTimeout(() => {this.verification_serial_txt = "Tapez un numéro de série"}, 2000);
        }
        else {
            if (this.serialtext.trim() !== "") {
                this.serial_selected_list.push(this.serialtext.trim());
                this.serialtext = "";
                this.quantity = this.serial_selected_list.length;
                if (this.serial_selected_list.length > 0) {
                    this.validate_active = false;
                } else if (this.serial_selected_list.length === 0) {
                    this.validate_active = true;
                }
            }
        }
    }

    Verif_in_out_cb(param: string): void {
        if (param === "OK") {
            this.Verif_local();
        } else {
            this.serialtext = "";
            this.verification_serial_txt = "Cet numéro de série n'existe pas";
            setTimeout(() => {this.verification_serial_txt = "Tapez un numéro de série"}, 2000);
        }

    }

    Verif_out_cb(param: string): void {
        if (param === "OK") {
            this.Verif_local();
        } else {
            this.serialtext = "";
            this.verification_serial_txt = "Cet produit a été déjà sorti";
            setTimeout(() => {this.verification_serial_txt = "Tapez un numéro de série"}, 2000);
        }

    }


    AddSerialNumber(): void {
        if (this.serialtext !== "") {
            // Test si serial ao anaty base
            if (this.article_management === "IN_OUT") {
                this.VerificationSerialNumberInOut(this.id_article, this.serialtext);
            } else {
                this.edit_serial_avalable = true;
                this.VerificationSerialNumberOut(this.id_article, this.serialtext);
            }
        }
    }

    SerialEditCtl(): void {
        if (this.serialtext === "" || this.serialtext === " ") {
            this.add_bt = true;
            this.operation_bt = "Ajouter";
        }
        else {
            this.add_bt = false;
        }
    }

    ModifyBt(serial: string): void {
        this.add_bt = false;
        this.operation_bt = "Modifier";
        this.serialtext = serial;

        this.indexofModif = this.serial_selected_list.indexOf(serial);

    }

    InitForm(): void {
        //ISSUE
        this.add_bt = true;
        this.operation_bt = "Ajouter";
        this.serialtext = "";

        //RECEIP
        this.quantity = 1;
        this.lot_name = "";
        this.lot_name_select = "";
        this.lot = "";
        this.serial_number = "";

        this.name = 'Article Infos';
        this.serial_number_disabled = true;
        this.lot_disabled = true;
        this.lot_select_disabled = true;
        this.qte_disabled = true;
        this.valid_bt = true;
        this.already_in = false;
    }

    GetResponse(response: string): void {
        this.serial_ok = response;
    }

    MofidySerialNumber(): void {
        var index = this.indexofModif;
        this.VerificationSerialNumberOut(this.id_article, this.serialtext);
        if ((this.serial_ok === "OK")) {
            this.serial_selected_list.splice(index, 1, this.serialtext);
        }
        this.InitForm();
    }

    ButtonOperation(): void {
        if (this.operation_bt === "Ajouter") {
            this.AddSerialNumber();
        } else {
            this.MofidySerialNumber();
        }
    }

    SupprBt(serial: string): void {
        var index = this.serial_selected_list.indexOf(serial);
        if (index > -1) {
            this.serial_selected_list.splice(index, 1);
            this.quantity = this.serial_selected_list.length;
            if (this.serial_selected_list.length > 0) {
                this.validate_active = false;
            } else if (this.serial_selected_list.length === 0) {
                this.validate_active = true;
            }
            this.InitForm();

        }
    }

    Validate(): void {
        let tmp = Number(this.quantity);
        if (!isNaN(tmp) && tmp !== 0) {
            this.validate_active = false;
        }
        else {
            this.validate_active = true;
        }
    }

    number_reference: any;
    SessionReceipStock(): void {
        this.lot = this.lot_name;
        this.docket_date = new Date();

        if (this.quantity.toString() === "") {
            this.quantity = 0;
        }
        if (this.lot_name === "") {
            this.lot = this.lot_name_select;
        }

        this.lots_service.SessionReceipt(this.id_article, this.name, this.quantity.toString(), this.lot, this.serial_number, this.management_mode).then(result => {
            if (result['list'] !== "") {
                this.prod_session_list = result['list'];
            }

            if (this.prod_session_list !== []) {
                this.validate_docket_bt = false;
            }
            if (result['result'] === 'KO') {
                this.SetReceipOperation(this.current_article);
                this.ManagementInfos(this.current_article); this.already_in = true; setTimeout(() => {this.already_in = false}, 3500);
            }
            else if (result['result'] === 'OK') {this.InitPopup()}

            this.number_reference = parseInt(result['last_number_reference']) + 1;
            this.docket_name = "Stock Initial";
        });
        this.InitForm();

        this.name = "";
        this.serial_management = "";
        this.lot_management = "";
    }

    EditAndValidateModification(prod: any): void {
        if (prod.status === "RECEPTION") {
            this.EditArticleSession(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSession(prod);
        }
    }

    EditArticleSession(prod: any): void {
        this.stocks_service.EditArticleSessionReceipt(prod.index).then(result => {this.prod_session_list = result['list']; this.SessionMod(result['list'])});
    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
    }

    ValidateEditArticleSession(prod: any): void {
        if (isNaN(prod.quantity)) {
            prod.quantity = "Valeur invalide";
            setTimeout(() => {this.LoadSessionDocket()}, 3500);
        }
        else {
            this.stocks_service.ValidateEditArticleSessionReceipt(prod).then(result => {this.prod_session_list = result['list']; this.SessionMod(result['list'])});
        }
    }

    articles_list: Array<any> = [];
    ReceiptDocket(): void {
        if (this.docket_name !== "") {
            this.lots_service.ReceiptDocket(this.docket_name, this.article_abstract_id).then(result => {
                this.prod_list = result['list'];
                this.lot_abstract = result['lot_abstract_list'];
                this.prod_session_list = [];
                this.validate_docket_bt = true;
                this.docket_name = "";
                this.form_not_valid = false;

                this.sortedData = result['list'];
                this.sort_table.SetDataArray(result['list'], [{value: "internal_code", type: ""}, {value: "name", type: ""}, {value: "cat", type: ""}, {value: "stocks", type: "number"}]);
                this.docket_date = undefined;
                this.number_reference = undefined;

                this.stock_article_service.getArticles(undefined)
                    .then(response => {
                        this.articles_list = response;
                    });
            });
        }
        else {
            this.form_not_valid = true;
            setTimeout(() => {this.form_not_valid = false}, 3000);
        }

    }

    LotKeyUpEvent(): void {
        if (this.lot_name !== "") {
            this.lot_select_disabled = true;
            this.lot_name_select = "";
        }
        else {
            this.lot_select_disabled = false;
        }
    }

    SerialNumberCtl(): void {
        if (this.serial_number === "") {
            this.valid_bt = true;
            this.validate_active = true;
        }
        else {
            this.validate_active = false;
            this.valid_bt = false;
        }
    }

    load_article(id: number): void {
        for (let i = 0; i < this.prod_list.length; i++) {
            if (this.prod_list[i].id_article == id) {
                this.SetReceipOperation(this.prod_list[i]);
            }
        }
    }

    GetArticle_cb(prod_list: ProductsArticle[]): void {
        this.prod_list = prod_list;
        this.route.params.subscribe((params: Params) => {
            let id = params['id'];

            if (id !== undefined) {
                this.app_component.valTest = '/initial-stock';
                this.app_component.GetParent();
                this.load_article(parseInt(id));
            }
        });
    }

    NumericalTest(quantity: string): void {
        if (isNaN(Number(quantity))) {
        }
    }

    RemoveArticleOfSession(prod: any): void {
        this.stocks_service.RemoveArticleSessionReceipt(prod.index).then(result => {this.prod_session_list = result['list']; if (this.prod_session_list.length === 0) {this.validate_docket_bt = true} });
    }

    setStyles(art: any) {
        let styles = {
            'color': 'red',
        };
        if (parseInt(art.stocks) != 0) {
            if (parseInt(art.stocks) >= parseInt(art.supply_thershold)) {
                styles = {'color': 'black'};
            } else {
                styles = {'color': 'orange'};
            }
        }

        return styles;
    }

    DownloadPdf(): void {
        this.filedownloadservice.InitialStock(this.docket_name, this.number_reference, this.datepipe.transform(this.docket_date, 'dd-MM-yyyy'));
    }

    CancelReceipt(): void {
        this.lots_service.CancelEnterInitialStock().then(result => {this.prod_session_list = result['list']});
        this.number_reference = undefined;
        this.docket_date = undefined;
        this.validate_docket_bt = true;
    }

}



// WEBPACK FOOTER //
// ./src/app/stock-initial.component.ts